import { Icon, Icons, Tooltip, TwoLinesCell } from '@silverfort/sf-components';
import { FC, SVGProps } from 'react';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import InvestigationDrawer from '../../../../components/InvestigationDrawer/InvestigationDrawer';
import { useAppDrawer } from '../../../../components/AppDrawer/AppDrawerProvider';

interface DisplayNameColumnProps {
    displayName: string;
    domainName: string;
    guid: string;
    onDisplayNameClick: (guid: string) => void;
}

const DisplayNameColumn: FC<DisplayNameColumnProps> = ({ displayName, domainName, guid, onDisplayNameClick }) => {
    const { displayContent } = useAppDrawer();

    return (
        <TwoLinesCell
            topElement={
                <Tooltip title={displayName} onlyOnOverflow onClick={() => onDisplayNameClick(guid)}>
                    <span className="truncate">{displayName}</span>
                </Tooltip>
            }
            bottomText={domainName}
            rightIcon={() => (
                <div>
                    <Tooltip title="Investigate" placement={'top-end'}>
                        <div
                            className={'invisible group-hover:visible'}
                            onClick={() =>
                                displayContent(<InvestigationDrawer guid={guid} adType={AD_ENTITY_TYPES.USER} />)
                            }>
                            <Icon
                                size={20}
                                icon={Icons.Investigate as FC<SVGProps<SVGSVGElement>>} // todo: real icon tbd
                                className="text-sf-gray-400"
                            />
                        </div>
                    </Tooltip>
                </div>
            )}
        />
    );
};

export default DisplayNameColumn;
